import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import yoproductsServiceClient from '../../common/helpers/yoproducts-service-client';
import { PER_MONTH, PER_YEAR, TOTAL, MONTH, API_TERM_VALUES } from '../../common/constants/periods';

export const getDomainPriceValue = ({ prices, tld, period, currency, priceType = 'current' }) =>
  get(prices, ['domain', tld, period, 'prices', priceType, currency], '0.00');

export const getPriceValue = ({ prices, plan, period, currency, priceType = 'current' }) =>
  get(prices, [plan, period, 'prices', priceType, currency], '0.00');

export const getPricePerMonth = (params, priceType = 'current') =>
  getPriceValue({ ...params, period: API_TERM_VALUES[PER_MONTH], priceType });

export const getPricePerYear = (params, priceType = 'current') =>
  getPriceValue({ ...params, period: API_TERM_VALUES[PER_YEAR], priceType });

export const getDomainPricePerYear = (params, priceType = 'current') =>
  getDomainPriceValue({ ...params, period: API_TERM_VALUES[PER_YEAR], priceType });

const getPriceData = ({ prices, plan, currency, locale }) => {
  if (isEmpty(prices)) {
    return {
      [PER_MONTH]: null,
      [PER_YEAR]: {
        [TOTAL]: null,
        [MONTH]: null,
      },
      extraPrice: {
        [PER_MONTH]: null,
        [PER_YEAR]: null,
      },
    };
  }

  const yoproducts = yoproductsServiceClient.get();

  // We have 2 types of 'per month' price representation:
  // either regular monthly, or yearly price divided by 12 months
  const pricePerMonth = getPricePerMonth({ prices, plan, currency });
  const pricePerYearTotal = getPricePerYear({ prices, plan, currency });
  const pricePerYearMonth = (pricePerYearTotal / 12).toFixed(2);
  const extraPricePerMonth = getPricePerMonth({ prices, plan, currency }, 'base');
  const extraPricePerYearTotal = getPricePerYear({ prices, plan, currency }, 'base');
  const extraPricePerYearMonth = (extraPricePerYearTotal / 12).toFixed(2);

  return {
    [PER_MONTH]: yoproducts.actions.formatPrice(pricePerMonth, locale, currency, {
      leadingCurrency: true,
    }),
    [PER_YEAR]: {
      [TOTAL]: yoproducts.actions.formatPrice(pricePerYearTotal, locale, currency, {
        leadingCurrency: true,
      }),
      [MONTH]: yoproducts.actions.formatPrice(pricePerYearMonth, locale, currency, {
        leadingCurrency: true,
      }),
    },
    extraPrice: {
      [PER_MONTH]: yoproducts.actions.formatPrice(extraPricePerMonth, locale, currency, {
        leadingCurrency: true,
      }),
      [PER_YEAR]: yoproducts.actions.formatPrice(extraPricePerYearMonth, locale, currency, {
        leadingCurrency: true,
      }),
    },
  };
};

export default getPriceData;
